import { Analytics as BaseAnalytics } from '@quicktools/shared-components';

import { HOTJAR_ID, TRACKING_ID, TRACKING_ID_4, VERSION, TOOL_NAME } from '../../configs';

import {
  CopyParams,
  CopywriterAnalitycsEventType,
  CtaClickParams,
  GenerateMoreParam,
  GenerateParam,
  PageClickParam,
  RephraseThisParam,
  ResultsActionParam,
  TabSelectParam,
  TextBoxClickParams,
  TextBoxTypeParams,
  TextGeneratedParam,
  ToolSelectParam,
} from './types';

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    dataLayer?: any[];
  }
}

class Analytics extends BaseAnalytics {
  public pageOpen(pagePath: string, pageName?: string) {
    this.gaEvent(
      CopywriterAnalitycsEventType.PAGE_OPEN,
      {
        page_path: pagePath,
        non_interaction: true,
        page_name: pageName,
      },
      true,
    );
    this.hjEvent(CopywriterAnalitycsEventType.PAGE_OPEN);
  }

  public ctaClick(params: CtaClickParams) {
    this.gaEvent(CopywriterAnalitycsEventType.CTA_CLICK, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.CTA_CLICK);
  }

  public textBoxClick(params: TextBoxClickParams) {
    this.gaEvent(CopywriterAnalitycsEventType.TEXT_BOX_CLICK, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.TEXT_BOX_CLICK);
  }

  public tabSelect(params: TabSelectParam) {
    this.gaEvent(CopywriterAnalitycsEventType.TAB_SELECT, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.TAB_SELECT);
  }

  public resultsAction(params: ResultsActionParam) {
    this.gaEvent(CopywriterAnalitycsEventType.RESULT_ACTION, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.RESULT_ACTION);
  }

  public pageClick(params: PageClickParam) {
    this.gaEvent(CopywriterAnalitycsEventType.PAGE_CLICK, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.PAGE_CLICK);
  }

  public generate(params: GenerateParam) {
    this.gaEvent(CopywriterAnalitycsEventType.GENERATE, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.GENERATE);
  }

  public textGenerated(params: TextGeneratedParam) {
    this.gaEvent(CopywriterAnalitycsEventType.TEXT_GENERATED, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.TEXT_GENERATED);
  }

  public textboxType(params: TextBoxTypeParams) {
    this.gaEvent(CopywriterAnalitycsEventType.TEXT_BOX_TYPE, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.TEXT_BOX_TYPE);
  }

  public generateMore(params: GenerateMoreParam) {
    this.gaEvent(CopywriterAnalitycsEventType.GENERATE_MORE, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.GENERATE_MORE);
  }

  public pillarToolSelect(params: ToolSelectParam) {
    this.gaEvent(CopywriterAnalitycsEventType.TOOL_SELECT, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.TOOL_SELECT);
  }

  public copy(params: CopyParams) {
    this.gaEvent(CopywriterAnalitycsEventType.TEXT_COPY_CONVERSATION, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.TEXT_COPY_CONVERSATION);
  }

  public rephraseThis(params: RephraseThisParam) {
    this.gaEvent(CopywriterAnalitycsEventType.REPHRASE_THIS, params, true);
    this.hjEvent(CopywriterAnalitycsEventType.REPHRASE_THIS);
  }
}

export default new Analytics({
  HOTJAR_ID,
  TRACKING_ID,
  TRACKING_ID_4,
  VERSION,
  TOOL_NAME,
});
